<template>
  <div>
    <bread-crumb path="内容管理" subPath="相关文章"></bread-crumb>
    <el-card>
      <el-row type="flex" justify="space-between" align="middle">
        <el-col :span="18">
          <div class="article-title">当前文章：{{ title }}</div>
        </el-col>
        <el-col :span="6" class="toolbar-right">
          <el-button @click="back">返回列表</el-button>
          <el-button type="primary" @click="saveRelated">保存</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            <span>已添加相关文章（最多3篇）</span>
          </div>
          <el-table :data="relatedList" stripe border :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="related_content_id" label="ID" width="80" align="center"></el-table-column>
            <el-table-column prop="pic" label="图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.pic" :src="scope.row.pic + '?imageView2/2/w/75'"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column label="排序" width="130" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.sort" :min="0" :step="1" size="mini"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="removeRelated(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card>
          <div slot="header">
            <el-input placeholder="搜索标题" v-model="param.keywords" clearable @clear="search">
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <el-table :data="contentList" stripe border :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
            <el-table-column prop="pic" label="图片" width="100" align="center">
              <template slot-scope="scope">
                <el-image v-if="scope.row.pic" :src="scope.row.pic + '?imageView2/2/w/75'"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" :disabled="isAdded(scope.row.id)" @click="addRelated(scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="param.page"
            :page-size="param.count"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'

export default {
  name: 'content_related',
  components: {
    'bread-crumb': BreadCrumb
  },
  data () {
    return {
      contentId: 0,
      title: '',
      returnParam: '',
      relatedList: [],
      contentList: [],
      total: 0,
      param: {
        keywords: '',
        page: 1,
        count: 5
      }
    }
  },
  mounted () {
    this.contentId = parseInt(this.$route.query.id || 0)
    this.title = this.$route.query.title || ''
    this.returnParam = this.$route.query.param || ''
    this.getRelatedList()
    this.getContentList()
  },
  methods: {
    async getRelatedList () {
      const res = await this.$http.get('/admin/content/related/list/' + this.contentId)
      if (res.code === 0) {
        this.relatedList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getContentList () {
      const res = await this.$http.get('/admin/content/list', this.param)
      if (res.code === 0) {
        this.contentList = res.data.list.filter(item => item.id !== this.contentId)
        this.total = res.data.total
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getContentList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getContentList()
    },
    isAdded (id) {
      return this.relatedList.some(item => item.related_content_id === id)
    },
    addRelated (row) {
      if (this.relatedList.length >= 3) {
        this.$message.error('最多添加3篇相关文章')
        return
      }
      if (row.id === this.contentId || this.isAdded(row.id)) {
        return
      }
      this.relatedList.push({
        related_content_id: row.id,
        title: row.title,
        pic: row.pic,
        sort: 0
      })
    },
    removeRelated (index) {
      this.relatedList.splice(index, 1)
    },
    async saveRelated () {
      const list = this.relatedList.map(item => {
        return {
          related_content_id: item.related_content_id,
          sort: item.sort
        }
      })
      const res = await this.$http.post('/admin/content/related/save/' + this.contentId, { list: list })
      if (res.code === 0) {
        this.$message.success('保存成功')
        this.getRelatedList()
      } else {
        this.$message.error(res.msg)
      }
    },
    back () {
      this.$router.push('/content/list?param=' + this.returnParam)
    }
  }
}
</script>

<style scoped>
.article-title {
  font-size: 16px;
  font-weight: bold;
}

.toolbar-right {
  text-align: right;
}

.el-card {
  margin-bottom: 20px;
}
</style>
